
















import { defineComponent } from '@nuxtjs/composition-api';
import VehiclesList from '@shared/components/Vehicles/VehiclesList.vue';
import useFitment from '@shared/composables/useFitment';
import useMyGarage from '@shared/composables/useMyGarage';
import { GarageVehicle } from '@shared/composables/useMyGarage/types';
import useToggleState from '@shared/composables/useToggleState';
import useVehiclesSidebar from '@shared/composables/useVehiclesSidebar';
import { VehicleSidebarState } from '@shared/system-constants';

import AMXButton from '~/components/AMXButton.vue';
import { Dropdown } from '~/components/AppHeader/constants';
import SidebarSubheading from '~/components/VehiclesSideBar/SidebarSubheading.vue';

export default defineComponent({
  name: 'DropdownGarage',
  components: { AMXButton, SidebarSubheading, VehiclesList },
  props: {},
  setup() {
    const { navigateToParts } = useFitment();
    const { setValue: setDropdownOpen } = useToggleState(Dropdown.Garage);
    const { vehicles, selectedVehicle, setSelectedVehicle } = useMyGarage();
    const { open: openSidebar } = useVehiclesSidebar();

    const onVehicleSelected = (vehicle: GarageVehicle) => {
      setSelectedVehicle(vehicle);
      setDropdownOpen(false);
    };

    const onShopPartsClicked = () => {
      setDropdownOpen(false);
      navigateToParts();
    };

    const onEditBikesClicked = () => {
      setDropdownOpen(false);
      openSidebar(VehicleSidebarState.GARAGE);
    };

    return {
      vehicles,
      selectedVehicle,
      onVehicleSelected,
      onShopPartsClicked,
      onEditBikesClicked,
    };
  },
});
